// First-paint atlas gate for the Pixi World subtree.
//
// CanvasInner warms the active theme's sprite atlas in a post-commit effect.
// LetterCubeSprites resolve their frame textures at construction time, so
// mounting World before the atlas is warm produces a cold-cache flash (empty
// cubes) on first paint. Gate the World mount on this predicate.

/**
 * Whether the World subtree may mount yet.
 *
 * - atlas ready → mount (textures resolve to real frames).
 * - atlas not ready BUT no theme set (themeKey null) → mount anyway: there is
 *   no atlas to wait for, and the effect that flips `atlasReady` never runs when
 *   themeKey is null, so gating on readiness alone would deadlock the board.
 * - atlas not ready WITH a theme → hold the mount until the warm-up resolves
 *   (CanvasInner also flips atlasReady=true on load FAILURE, so a genuine atlas
 *   error still mounts and degrades to EMPTY rather than hanging).
 */
export function shouldMountWorld(
  atlasReady: boolean,
  themeKey: string | null,
): boolean {
  return atlasReady || themeKey === null
}
